import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';
import { sortBy } from 'lodash';
import { getAllModules, Module } from '../../api/ExtensionService';
import { StoreState } from '../../store/store';

export const fetchModules = createAsyncThunk<
  Module[],
  undefined,
  { state: StoreState }
>('module/fetchModules', async () => {
  const publicData = await getAllModules(true);
  const privateData = await getAllModules(false);
  return [...publicData, ...privateData];
});

export interface ModulesState {
  allModules: Module[];
}

const initialState: ModulesState = {
  allModules: [],
};

export const selectAllModules = createSelector(
  (state: StoreState) => state.modules.allModules,
  (allModules: Module[]) => sortBy(allModules, [m => m.name.toUpperCase()])
);

export const selectModuleById =
  (moduleID: string, extensionUUID: string) => (state: StoreState) => {
    let module: Module = {
      objectUUID: '',
      id: '',
      name: '',
      pluginUUID: '',
      description: '',
    };
    state.modules.allModules.find(item => {
      if (item.id === moduleID && item.pluginUUID === extensionUUID) {
        module = item;
        return true;
      }
      return false;
    });
    return module;
  };

const { reducer } = createSlice({
  name: 'modules',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchModules.pending, state => ({
      ...state,
      allModules: [],
    }));
    builder.addCase(fetchModules.rejected, state => ({
      ...state,
      allModules: [],
    }));
    builder.addCase(fetchModules.fulfilled, (state, action) => {
      return {
        ...state,
        allModules: action.payload,
      };
    });
  },
});

export default reducer;
